<template>
  <div :id="id" class="modal fade" role="dialog">
    <div :class="['modal-dialog', `modal-${size}`]">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    id: {
      default: 'myModal',
      type: String,
      required: true
    },
    size: {
      default: 'lg',
      type: String,
    }
  },
  methods: {
    async listenCloseModal() {
      $(`#${this.id} .close`).click(e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        $(`#${this.id}`).modal("hide");

        if ($(".modal").length == 0) {
          $("body").removeClass("modal-open");
        }

        return false;
      });
    }
  },
  async mounted() {
    await this.listenCloseModal()
  }
};

</script>
<style >

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/Modal.vue